<template>
  <div>
    <div>
      <el-table
        ref='componentTable'

        :data='data'
        :stripe='stripe'
        :border='border'
        :size='size'
        :fit='fit'
        row-key='GUID'
        :cell-style='cellStyle'
        :row-style='rowStyle'
        :header-cell-style='headerCellStyle'
        :height='tableHeight'
        :default-expand-all='defaultExpandAll'
        :expand-row-keys='expandRowKeys'
        :show-summary='showSummary'
        :sum-text='sumText'
        :summary-method='summaryMethod'
        :span-method='spanMethod'

        @select='select'
        @select-all='selectAll'
        @selection-change='selectionChange'
        @cell-mouse-enter='cellMouseEnter'
        @cell-mouse-leave='cellMouseLeave'
        @cell-click='cellClick'
        @cell-dblclick='cellDblclick'
        @row-click='rowClick'
        @row-contextmenu='rowContextmenu'
        @row-dblclick='rowDblclick'
        @header-click='headerClick'
        @header-contextmenu='headerContextmenu'
        @sort-change='sortChange'
        @filter-change='filterChange'
        @current-change='currentChange'
        @header-dragend='headerDragend'
        @expand-change='expandChange'>

        <el-table-column type='expand' fixed v-if='showDefaultExpandColumn'>
          <template #default='scope'>
            <div class='expand-panel' v-for='column in disPlayColumnInfo' :key='leftPad(column.Seq) + column.ColumnCode'>
              <div class='expand-row-left'>{{column.ColumnName}}</div>
              <div class='expand-row-right'>
                <span v-if='column.CustomDisplay === "0"'>{{dataHandling(scope, column)}}</span>
                <slot :name='"slot-" + column.ColumnCode' :data='scope'
                  v-if='column.CustomDisplay === "1"'></slot>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column type='expand' fixed v-if='showExpandColumn'>
          <template #default='scope'>
            <slot name='expand' :data='scope'></slot>
          </template>
        </el-table-column>

        <el-table-column type='selection' fixed v-if='showSelectionColumn'
          :selectable='selectable' align='center'>
        </el-table-column>

        <el-table-column prop='RowId' label='序号' :width='seqWidth' :fixed='seqFixed' v-if='showSeqColumn' align='center'>
        </el-table-column>

        <el-table-column v-for='column in disPlayColumnInfo'
          :key='leftPad(column.Seq) + column.ColumnCode' :prop='column.ColumnCode'
          :show-overflow-tooltip='column.ShowOverflowTooltip === "1" ? true : false'
          :label='column.ColumnName'
          :width='column.Width'
          :align='column.TextAlign === "1" ? "center" : column.TextAlign === "2" ? "right" : "left"'
          :fixed='column.FixedFlag === "1" ? "left" : column.FixedFlag === "2" ? "right" : false'
          :sortable='column.Sortable === "1" ? "custom" : false'>
          <template #header>
            <slot :name='"headerSlot-" + column.ColumnCode'></slot>
            <span>{{column.ColumnName}}</span>
          </template>
          <template #default='scope'>
            <span :style='(column.Color ? ("color:" + column.Color + ";") : "") + (column.TextAlign ? ("text-align:" + column.TextAlign + ";") : "")'
              v-if='column.CustomDisplay === "0"'>{{dataHandling(scope,column)}}</span>
            <slot :name='"slot-" + column.ColumnCode' :data='scope'
              v-if='column.CustomDisplay === "1"'></slot>
          </template>
        </el-table-column>

        <el-table-column label='操作' :width='operationColumnWidth' fixed='right' v-if='showOperationsColumn'>
          <template #default='scope'>
            <slot name='OperationColumnslot' :data='scope'></slot>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class='pagination tableButtom' v-if='showButtomPage'>
      <el-pagination
        @size-change='sizeChange'
        @current-change='pageChange'
        :current-page='page'
        :page-sizes='pageSizes'
        :page-size='pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import code from '@/components/sys/Code'

export default {
  name: 'Table',
  props: {
    data: {
      default: function () {
        return []
      },
      type: Array
    },
    height: {
      default: null,
      type: String
    },
    stripe: {
      default: false,
      type: Boolean
    },
    border: {
      default: true,
      type: Boolean
    },
    showButtomPage: {
      default: true,
      type: Boolean
    },
    size: {
      default: 'medium',
      type: String
    },
    fit: {
      default: true,
      type: Boolean
    },
    defaultExpandAll: {
      default: false,
      type: Boolean
    },
    showSummary: {
      default: false,
      type: Boolean
    },
    summaryMethod: {
      default: function ({ columns, data }) {
        const sums = []
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = ''
          }
        })
        return sums
      },
      type: Function
    },
    sumText: {
      default: '合计',
      type: String
    },
    cellStyle: {
      default: function () {
        return { padding: '0px' }
      },
      type: [Object, Function]
    },
    rowStyle: {
      default: function () {
        return {}
      },
      type: [Object, Function]
    },
    headerCellStyle: {
      default: function () {
        return { padding: '2px', background: '#f5f7fa' }
      },
      type: [Object, Function]
    },
    expandRowKeys: {
      default: null,
      type: Array
    },
    tableInfo: {
      default: function () {
        return {}
      },
      type: Object
    },
    columnInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    disPlayColumnInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    showDefaultExpandColumn: {
      default: false,
      type: Boolean
    },
    showExpandColumn: {
      default: false,
      type: Boolean
    },
    showSelectionColumn: {
      default: true,
      type: Boolean
    },
    seqWidth: {
      default: '60',
      type: String
    },
    seqFixed: {
      default: true,
      type: Boolean
    },
    showSeqColumn: {
      default: true,
      type: Boolean
    },
    showOperationsColumn: {
      default: true,
      type: Boolean
    },
    operationColumnWidth: {
      default: '120px',
      type: [String, Number]
    },
    pageSizes: {
      default: function () {
        return [10, 20, 50, 100, 200]
      },
      type: Array
    },
    pageSize: {
      default: 50,
      type: Number
    },
    page: {
      default: 1,
      type: Number
    },
    total: {
      default: 0,
      type: Number
    },
    reduceHeight: {
      default: 170,
      type: Number
    },
    boolDisplay: {
      default: function (val) {
        if (val === true) {
          return '是'
        } else if (val === false) {
          return '否'
        }
      },
      type: Function
    },
    getSpecialStringArray: {
      default: null,
      type: Function
    },
    spanMethod: {
      default: null,
      type: Function
    },
    selectable: {
      default: null,
      type: Function
    }
  },

  updated: function () {
    const that = this
    that.$nextTick(() => {
      that.$refs.componentTable.doLayout()
    })
  },

  computed: {
    tableHeight: function () {
      const that = this
      if (that.height) {
        return that.height
      }
      return (window.innerHeight - that.reduceHeight) - (that.$store.state.showTabs ? 40 : 0) + 25 - (window.innerWidth > 1440 ? 0 : (window.innerWidth > 960 ? 40 : 80)) + 'px'
    },
    codes: function () {
      return this.$store.state.codes
    }
  },

  methods: {
    select: function (selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll: function (selection) {
      this.$emit('select-all', selection)
    },
    selectionChange: function (selection) {
      this.$emit('selection-change', selection)
    },
    cellMouseEnter: function (row, column, cell, event) {
      this.$emit('cell-mouse-enter', row, column, cell, event)
    },
    cellMouseLeave: function (row, column, cell, event) {
      this.$emit('cell-mouse-leave', row, column, cell, event)
    },
    cellClick: function (row, column, cell, event) {
      if (column.label !== '操作' && column.type !== 'expand') {
        row.flag = !row.flag
        this.$refs.componentTable.toggleRowSelection(row, row.flag)
      }
      this.$emit('cell-click', row, column, cell, event)
    },
    cellDblclick: function (row, column, cell, event) {
      this.$emit('cell-dblclick', row, column, cell, event)
    },
    rowClick: function (row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    rowContextmenu: function (row, event) {
      this.$emit('row-contextmenu', row, event)
    },
    rowDblclick: function (row, event) {
      this.$emit('row-dblclick', row, event)
    },
    headerClick: function (column, event) {
      this.$emit('header-click', column, event)
    },
    headerContextmenu: function (column, event) {
      this.$emit('header-contextmenu', column, event)
    },
    sortChange: function ({ column, prop, order }) {
      this.$emit('sort-change', { column, prop, order })
    },
    filterChange: function (filters) {
      this.$emit('filter-change', filters)
    },
    currentChange: function (currentRow, oldCurrentRow) {
      this.$emit('current-change', currentRow, oldCurrentRow)
    },
    headerDragend: function (newWidth, oldWidth, column, event) {
      this.$emit('header-dragend', newWidth, oldWidth, column, event)
    },
    expandChange: function (row, expandedRows) {
      this.$emit('expand-change', row, expandedRows)
    },
    sizeChange: function (val) {
      this.$emit('size-change', val)
    },
    pageChange: function (val) {
      this.$emit('page-change', val)
    },
    leftPad: function (number) {
      if (number < 10) {
        return '00' + number
      } else if (number < 100) {
        return '0' + number
      } else if (number < 1000) {
        return '' + number
      }
    },
    dataHandling: function (scope, column) {
      const that = this
      if (column.DataType === '0') {
        return scope.row[column.ColumnCode]
      } else if (column.DataType === '1') {
        if (scope.row[column.ColumnCode] === undefined || scope.row[column.ColumnCode] === null) {
          return ''
        }
        if (column.DecimalDigits >= 20) {
          return scope.row[column.ColumnCode]
        } else {
          return scope.row[column.ColumnCode].toFixed(column.DecimalDigits)
        }
      } else if (column.DataType === '2') {
        if (scope.row[column.ColumnCode] === undefined || scope.row[column.ColumnCode] === null) {
          return ''
        }
        return Math.round(scope.row[column.ColumnCode])
      } else if (column.DataType === '3' && that.$props.boolDisplay) {
        return that.$props.boolDisplay(scope.row[column.ColumnCode], column.ColumnCode)
      } else if (column.DataType === '4') {
        return scope.row[column.ColumnCode]
      } else if (column.DataType === '5' && that.$props.getSpecialStringArray) {
        const arys = that.$props.getSpecialStringArray(column.ColumnCode)
        if (arys && arys.length > 0) {
          for (let i = 0; i < arys.length; i++) {
            if (scope.row[column.ColumnCode] === arys[i].code) {
              return arys[i].name
            }
          }
          return scope.row[column.ColumnCode]
        } else if (column.DateFormat) {
          const sysArys = code.getCode(that.codes, column.DateFormat)
          for (let i = 0; i < sysArys.length; i++) {
            if (scope.row[column.ColumnCode] === sysArys[i].code) {
              return sysArys[i].name
            }
          }
          return scope.row[column.ColumnCode]
        } else {
          return scope.row[column.ColumnCode]
        }
      }
    }
  }
}
</script>

<style scoped>
.tableButtom {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 5px;
}
.expand-left {
  width: 120px;
  height: 35px;
  color: #99a9bf;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.expand-right {
  color: #000000;
  text-align: left;
}
.expand-panel {
  width: calc(100% - 100px);
  margin-left: 116px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 2px;
  border-bottom: 1px solid #efefef;
}
.expand-row-left {
  width: 120px;
  min-height: 25px;
  color: #aaaaaa;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.expand-row-right {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
